import { render, staticRenderFns } from "./cCol.vue?vue&type=template&id=24bf34c6&scoped=true&"
import script from "./cCol.vue?vue&type=script&lang=js&"
export * from "./cCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf34c6",
  null
  
)

export default component.exports